// Director-only SP2 recommendations — wrapper around /api/miniapp/recommendations.
// Read-only funnel-bottleneck cards (diagnosis + recommendation). The bodies are
// server-rendered Russian; the screen localizes only its chrome.
import { apiRequest } from './client'

export interface SuggestedAction {
  type: string            // "add_stage_task" | "review_stage"
  day?: number
}

export interface RecommendationCard {
  stage_ext: string
  stage_name: string
  kind: 'slow_stage' | 'low_conversion' | 'stuck_deals'
  severity: number
  metrics?: Record<string, number>
  diagnosis_ru: string
  recommendation_ru: string
  suggested_action?: SuggestedAction
  pipeline_ext?: string
  applied?: boolean
}

export interface RecommendationsResponse {
  data_state: 'ok' | 'insufficient'
  computed_at: string
  pipeline_name?: string | null
  cards: RecommendationCard[]
}

export function fetchRecommendations(): Promise<RecommendationsResponse> {
  return apiRequest<RecommendationsResponse>('/api/miniapp/recommendations')
}

export interface ApplyResult {
  applied: boolean
  already: boolean
  auto_execute_moves: boolean
}

export function applyRecommendation(card: RecommendationCard): Promise<ApplyResult> {
  return apiRequest<ApplyResult>('/api/miniapp/recommendations/apply', {
    method: 'POST',
    body: {
      pipeline_ext: card.pipeline_ext,
      stage_ext: card.stage_ext,
      kind: card.kind,
      action: card.suggested_action,
    },
  })
}
